import { motion } from "framer-motion";
import { ScanLine, Workflow, ShieldCheck, Eye, Scale, Receipt, FileSignature } from "lucide-react";

const services = [
  {
    icon: Workflow,
    title: "Flujos Rápidos con Firmas Electrónicas",
    desc: "Procesos simples con firma electrónica y archivo digital. Operativo en 8–12 semanas, con auditoría y capacitación incluidas. Cumple con la normativa de firma electrónica vigente en tu país.",
  },
  {
    icon: ScanLine,
    title: "Digitalización a Gran Escala",
    desc: "Escalamos la digitalización a contratos, compras y RRHH, con soporte continuo. Alineado con los estándares de transparencia y trazabilidad documental de cada país.",
  },
  {
    icon: Receipt,
    title: "Procesamiento de Facturas",
    desc: "Digitaliza, captura y aprueba facturas de proveedores de forma automática. Operativo en 4–6 semanas, con flujos de aprobación configurables y trazabilidad completa de cada pago.",
  },
  {
    icon: FileSignature,
    title: "Gestión de Contratos",
    desc: "Centraliza contratos de arrendamiento, compraventa y proveedores con control de versiones, alertas de vencimiento y firma electrónica integrada. Encuentra cualquier contrato en segundos.",
  },
  {
    icon: ShieldCheck,
    title: "Gobernanza y Retención Segura",
    desc: "Políticas de retención, legal hold y auditorías con dashboards personalizados. Optimiza compliance en semanas.",
  },
  {
    icon: Eye,
    title: "Supervisión de Digitalización",
    desc: "Gestionamos la digitalización con aliados locales, asegurando calidad en escaneo y OCR con supervisión experta.",
  },
  {
    icon: Scale,
    title: "Evidencia Legal y Cumplimiento",
    desc: "Garantiza trazabilidad con soluciones que cumplen la normativa fiscal y documental de cada país (FEL/SAT en Guatemala, CFDI/SAT en México, y equivalentes en el resto de la región).",
  },
];

const cardVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: (i: number) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.5, delay: i * 0.1 },
  }),
};

const Services = () => (
  <section id="servicios" className="py-24 section-gradient">
    <div className="container">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="text-center max-w-2xl mx-auto mb-16"
      >
        <span className="text-sm font-semibold tracking-wider uppercase text-primary mb-3 block">
          Servicios
        </span>
        <h2 className="text-3xl sm:text-4xl font-bold text-foreground mb-4">
          Soluciones de Digitalización y Cumplimiento
        </h2>
        <p className="text-muted-foreground text-lg">
          Transformamos la gestión documental con soluciones ágiles, seguras y conformes a la normativa vigente en cada país que atendemos.
        </p>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {services.map((s, i) => (
          <motion.div
            key={s.title}
            custom={i}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={cardVariants}
            className="glass glass-hover rounded-2xl p-8 flex flex-col"
          >
            <div className="w-12 h-12 rounded-xl bg-accent flex items-center justify-center mb-5">
              <s.icon size={24} className="text-accent-foreground" />
            </div>
            <h3 className="text-lg font-semibold text-foreground mb-3">{s.title}</h3>
            <p className="text-muted-foreground text-sm leading-relaxed flex-1">{s.desc}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default Services;
